import { Badge, Icon, IconName } from '@usealloy/component-library';
import React from 'react';

import type { ServiceNode as IServiceNode, WorkflowNodeProps } from 'flow/service/graph';

import BaseNode from '../BaseNode';
import { useAppSelector } from '~/store/reduxHooks';
import { selectActionByPublicId, selectNodeState, selectServiceProp } from 'flow/store/redux/selectors';
import { showNodeMenu } from '../BaseNode/helpers';
import { StyledLabelText } from './styles';
import { serviceHasAttributes } from 'flow/service/services';


function ServiceNode(props: WorkflowNodeProps<IServiceNode>) {
  const { id, type, data: { label } } = props;
  const action = useAppSelector(selectActionByPublicId(id));
  const serviceProp = useAppSelector(selectServiceProp(action?.service.internalName));
  const nodeState = useAppSelector(state => selectNodeState(state, id));
  const hasAttributes = serviceProp ? serviceHasAttributes(serviceProp) : false;

  const customListMajorVersion = action && action.options?.custom_list_major_version?.value;
  const serviceVersion = customListMajorVersion ? `v${customListMajorVersion}` : '';

  const isChildAccountPlaceholderList = label === 'Customer Allow List Placeholder'
    || label === 'Customer Deny List Placeholder';

  const stateStyle = isChildAccountPlaceholderList ? {
    baseBackgroundColor: '#FFFFFF',
    normal: {
      border: 'solid var(--cl-green-300)',
    },
    highlighted: {
      border: 'solid var(--cl-green-200)',
    },
    hovered: {
      border: 'solid var(--cl-green-200)',
    },
  } : {
    baseBackgroundColor: 'var(--cl-green-300)',
    highlighted: {
      backgroundColor: 'var(--cl-green-200)',
    },
    hovered: {
      backgroundColor: 'var(--cl-green-200)',
    },
  };

  const LabelTextComponent = (
    <StyledLabelText showVersionBadge={!!serviceVersion}>
      {label}
    </StyledLabelText>
  );

  return (
    <BaseNode
      icon={
        <Icon icon={IconName.Cube} size="large" />
      }
      id={id}
      label={LabelTextComponent}
      stateStyle={stateStyle}
      type={type}
      disable={{ nodeConnector: !hasAttributes }}
    >
      {serviceVersion && (
        <Badge
          outline
          status="success"
          style={{
            // add space between service name and version
            marginLeft: 'var(--cl-space-1)',
            // adjust for node dropdown visibility
            marginRight: showNodeMenu(nodeState, type)
              ? 'var(--cl-space-1)' : 'var(--cl-space-5)',
          }}
        >
          {serviceVersion}
        </Badge>
      )}
    </BaseNode>
  );
}

export default React.memo(ServiceNode);
